<template>
  <v-chart :option="option" :style="{width,height}" autoresize class="chart-container" />
</template>

<script>
import VChart from 'vue-echarts'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import { use } from 'echarts/core'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'
// 引入柱状图图表，图表后缀都为 Chart
import {
  LineChart
} from 'echarts/charts'
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
  TooltipComponent,
  GridComponent
} from 'echarts/components'
use([
  CanvasRenderer,
  TooltipComponent,
  GridComponent,
  LineChart
])
export default {
  name: 'WhCharts',
  components: { VChart },
  props: {
    option: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: undefined
    },
    height: {
      type: String,
      default: '400px'
    }
  }
}
</script>

<style lang="less" scoped>
</style>
